import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-cardBg border-t border-warmBrown/20 text-center px-4" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <p className="font-serif text-sm text-gray-500 leading-relaxed" data-id="element-99">
          <strong data-id="element-100">Disclaimer:</strong> Dies ist ein persönlicher
          Erfahrungsbericht. Ergebnisse können individuell variieren. Bei
          anhaltenden Beschwerden bitte einen Tierarzt aufsuchen.
        </p>
      </div>
    </footer>;
}